import { useCallback, useState } from 'react';
import { ICommerceVariant, StockStatus } from '~/types/ICommerceVariant';
import { PeriodType } from '~/types/IPurchase';

type Amount = number | null | undefined;

export type CommerceProductState = {
  values: {
    price: Amount;
    customPrice: boolean;
    quantity: number;
    period: PeriodType;
    stockStatus?: StockStatus;
  };
  handlers: {
    setPrice: (value: Amount) => void;
    setCustomPrice: (value: boolean) => void;
    setQuantity: (value: number) => void;
    setPeriod: (value: PeriodType) => void;
    resetPrice: () => void;
  };
};

type Props = {
  variant: ICommerceVariant;
};

export function useCommerceProductState({
  variant
}: Props): CommerceProductState {
  const [price, setPrice] = useState<Amount>(variant?.price?.value || null);

  const [customPrice, setCustomPrice] = useState<boolean>(false);
  const [quantity, setQuantity] = useState(1);
  const [period, setPeriod] = useState<PeriodType>(variant?.period || 'Once');

  const resetPrice = useCallback(() => setPrice(null), []);

  return {
    values: {
      price,
      customPrice,
      quantity,
      period,
      stockStatus: variant?.stock?.status
    },
    handlers: {
      resetPrice,
      setPrice,
      setQuantity,
      setPeriod,
      setCustomPrice
    }
  };
}
